import React, { useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { useCheckLogin } from '@/hooks/useAuth';

const BASE_NAV_ITEMS = [
  {
    path: '/weeklyreport',
    label: 'Report',
    icon: 'solar:chart-bold-duotone',
  },
  {
    path: '/spacecalendar/conjunctions',
    label: 'Conjunction',
    icon: 'solar:rocket-bold-duotone',
  },
  {
    path: '/spacecalendar',
    label: 'Calendar',
    icon: 'solar:calendar-bold-duotone',
  },
  {
    path: '/mobile-contact',
    label: 'Contact',
    icon: 'material-symbols:mail',
  },
];

const HIDE_NAV_BAR: string[] = ['/privacy-policy', '/astar'];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: userData } = useCheckLogin();
  const isLoggedIn = !!userData;

  const NAV_ITEMS = useMemo(() => {
    const userNavItem = isLoggedIn
      ? {
          path: '/user/mypage',
          label: 'My Page',
          icon: 'icon-park-solid:me',
        }
      : {
          path: '/user/login',
          label: 'Login',
          icon: 'material-symbols:login',
        };
    return [...BASE_NAV_ITEMS, userNavItem];
  }, [isLoggedIn]);

  const isActive = useCallback(
    (itemPath: string) => {
      const currentPath = location.pathname;
      if (itemPath === '/spacecalendar/conjunctions') {
        return currentPath === '/spacecalendar/conjunctions';
      }
      if (itemPath === '/spacecalendar/faq') {
        return currentPath === '/spacecalendar/faq';
      }
      if (itemPath === '/spacecalendar') {
        return (
          currentPath === '/spacecalendar' ||
          currentPath === '/spacecalendar/' ||
          currentPath.startsWith('/spacecalendar/events')
        );
      }
      if (itemPath === '/user/login') {
        return (
          currentPath === '/user/login' ||
          currentPath === '/user/signup' ||
          currentPath === '/privacy-policy'
        );
      }
      if (itemPath === '/user/mypage') {
        return currentPath === '/user/mypage';
      }
      return currentPath === itemPath;
    },
    [location.pathname]
  );

  if (HIDE_NAV_BAR.includes(location.pathname)) {
    return null;
  }

  const navItems = NAV_ITEMS.map(item => {
    const active = isActive(item.path);
    return (
      <button
        key={item.path}
        onClick={() => navigate(item.path)}
        className={`flex flex-col items-center justify-center bg-transparent border-none cursor-pointer p-2 w-1/5 transition-all duration-200 ${
          active ? 'text-[#FCCB16]' : 'text-white hover:text-white'
        }`}
      >
        <Icon
          icon={item.icon}
          width='20'
          height='20'
          style={{ color: 'currentColor' }}
        />
        <span className='text-xs mt-1'>{item.label}</span>
      </button>
    );
  });

  return (
    <nav className='fixed bottom-0 left-0 right-0 h-[70px] bg-black flex justify-around items-start z-[1000] border-t border-[#333333] m-0 px-2 py-0'>
      {navItems}
    </nav>
  );
};

export default MobileBottomNav;
